import { faPhoneMissed, faUserSlash } from '@fortawesome/pro-solid-svg-icons'

import { addAllValue } from 'src/utils/DataTrees'
import { addAllValue as addAllValueV5 } from 'src/utils/v5/DataTrees'

export const statusesById = new Map([
  [1, 'Pending'],
  [2, 'Pre-Active'],
  [3, 'Active'],
  [4, 'On Hold'],
  [5, 'Discharged'],
  [6, 'Inactive']
])

export const statusesByName = new Map([
  ['Pending', 1],
  ['Pre-Active', 2],
  ['Active', 3],
  ['On Hold', 4],
  ['Discharged', 5]
])

export const STATUSES = new Map([
  ['New', 1],
  ['In progress', 2],
  ['Inactive', 5],
  ['Closed', 5],
  ['Completed', 10]
])

export const STATUSES_BY_NAME_AS_CONST = {
  pending: { title: 'Pending', value: 1 },
  preActive: {
    title: 'Pre-Active',
    value: 2
  },
  active: { title: 'Active', value: 3 },
  onHold: { title: 'On Hold', value: 4 },
  discharged: { title: 'Discharged', value: 5 }
} as const

export const STATUSES_BY_NAME = new Map([
  [
    'Pending',
    {
      title: 'Pending',
      className: 'status-pending',
      value: 1
    }
  ],
  [
    'Pre-Active',
    {
      title: 'Pre-Active',
      className: 'status-pre-active',
      value: 2
    }
  ],
  [
    'Active',
    {
      title: 'Active',
      className: 'status-active',
      value: 3
    }
  ],
  [
    'On Hold',
    {
      title: 'On Hold',
      className: 'status-on-hold',
      value: 4
    }
  ],
  [
    'Discharged',
    {
      title: 'Discharged',
      className: 'status-discharged',
      value: 5
    }
  ]
])

export const STATUSES_BY_NUMBERS = new Map([
  [
    0,
    {
      title: '-',
      className: '',
      value: 0
    }
  ],
  [
    1,
    {
      title: 'New',
      className: 'status-new',
      value: 1
    }
  ],
  [
    2,
    {
      title: 'In progress',
      className: 'status-in-progress',
      value: 2
    }
  ],
  [
    3,
    {
      title: 'Closed',
      className: 'status-closed',
      value: 3
    }
  ],
  [
    4,
    {
      title: 'On Hold',
      className: 'status-on-hold',
      value: 4
    }
  ],
  [
    5,
    {
      title: 'Closed',
      className: 'status-closed',
      value: 5
    }
  ],
  [
    10,
    {
      title: 'Completed',
      className: 'status-completed',
      value: 10
    }
  ]
])

export const STATUSES_BY_NUMBERS_SECOND_TIER = new Map([
  [
    0,
    {
      title: '-',
      className: '',
      value: 0
    }
  ],
  [
    1,
    {
      title: 'Pending',
      className: 'status-pending',
      value: 1
    }
  ],
  [
    2,
    {
      title: 'Pre-active',
      className: 'status-pre-active',
      value: 2
    }
  ],
  [
    3,
    {
      title: 'Active',
      className: 'status-active',
      value: 3
    }
  ],
  [
    4,
    {
      title: 'On Hold',
      className: 'status-on-hold',
      value: 4
    }
  ],
  [
    5,
    {
      title: 'Discharged',
      className: 'status-discharged',
      value: 5
    }
  ]
])

export const STATUSES_BY_NUMBERS_SECOND_TIER_DROPDOWN_WTIH_ALL = addAllValue(
  Array.from(STATUSES_BY_NUMBERS_SECOND_TIER)
    .map(([key, item]) => ({ key, ...item }))
    .filter(({ value }) => value)
    .sort((a, b) => {
      if (a.title < b.title) {
        return -1
      } else if (a.title > b.title) {
        return 1
      }

      return 0
    })
)

export const STATUSES_BY_NUMBERS_SECOND_TIER_DROPDOWN_WTIH_ALL_V5 = addAllValue(
  Array.from(STATUSES_BY_NUMBERS_SECOND_TIER)
    .map(([key, { title, value }]) => ({ key, label: title, title, value }))
    .filter(({ value }) => value)
    .sort((a, b) => {
      if (a.title < b.title) {
        return -1
      } else if (a.title > b.title) {
        return 1
      }

      return 0
    }),
  false,
  'All',
  ''
)

export const STATUSES_BY_NUMBERS_SECOND_TIER_NO_PENDING_WITH_ALL = addAllValue(
  Array.from(STATUSES_BY_NUMBERS_SECOND_TIER)
    .map(([key, item]) => ({ key, ...item }))
    .filter(({ title, value }) => value && title !== 'Pending')
    .sort((a, b) => {
      if (a.title < b.title) {
        return -1
      } else if (a.title > b.title) {
        return 1
      }

      return 0
    })
)

export const STATUSES_BY_NUMBERS_SECOND_TIER_NO_PENDING_WITH_ALL_V5 =
  addAllValueV5({
    list: Array.from(STATUSES_BY_NUMBERS_SECOND_TIER)
      .map(([key, item]) => ({ key, ...item }))
      .filter(({ title, value }) => value && title !== 'Pending'),
    convertList: true
  })

export const PATIENT_STATUSES = new Map([
  [
    0,
    {
      title: 'Inactive',
      className: 'status-inactive',
      value: 0
    }
  ],
  [
    1,
    {
      title: 'Active',
      className: 'status-active',
      value: 1
    }
  ]
])

export const PRIORITY = new Map([
  [
    0,
    {
      title: '',
      className: 'priority-none',
      cellClassName: '',
      value: 0
    }
  ],
  [
    1,
    {
      title: 'Low',
      className: 'priority-low',
      cellClassName: 'link-yellow',
      value: 1
    }
  ],
  [
    2,
    {
      title: 'Medium',
      className: 'priority-medium',
      cellClassName: 'link-orange',
      value: 2
    }
  ],
  [
    3,
    {
      title: 'High',
      className: 'priority-high',
      cellClassName: 'link-red',
      value: 3
    }
  ]
])

export const ALERT_PRIORITY = new Map([
  [
    0,
    {
      className: 'priority-no-escalation',
      text: 'No Escalation',
      title: 'No Escalation',
      value: 0
    }
  ],
  [
    1,
    {
      className: 'priority-low',
      text: 'Alert: LOW',
      title: 'Low',
      value: 1
    }
  ],
  [
    2,
    {
      className: 'priority-medium',
      text: 'Alert: MEDIUM',
      title: 'Medium',
      value: 2
    }
  ],
  [
    3,
    {
      className: 'priority-high',
      text: 'Alert: HIGH',
      title: 'High',
      value: 3
    }
  ]
])

export const alertsPrioritiesNumber = new Map([
  ['low', 1],
  ['medium', 2],
  ['high', 3]
])

export const PRIORITY_FOR_DROPDOWN = Array.from(PRIORITY)
  .filter(([_, { value }]) => value !== 0)
  .map(([key, { title, value }]) => ({ key, value, title, label: title }))

export const PRIORITY_FOR_DROPDOWN_WITH_ALL = addAllValueV5({
  list: PRIORITY_FOR_DROPDOWN,
  convertList: false
})
export const getStatusTitleById = (id) => statusesById.get(id)

export const getStatusIdByTitle = (title) => {
  if (typeof title !== 'string') {
    return undefined
  }
  return statusesByName.get(title.trim().toUpperCase())
}

export const PATIENT_STATUS_FOR_DROPDOWN = Array.from(statusesByName)
  .map(([title, value]) => ({ title, value }))
  .sort((a, b) => {
    if (a.title < b.title) {
      return -1
    } else if (a.title > b.title) {
      return 1
    }

    return 0
  })

export const PATIENT_STATUS_FOR_DROPDOWN_V5 = PATIENT_STATUS_FOR_DROPDOWN.map(
  ({ title, value }, key) => ({ key, label: title, value, label: title })
)

export const PATIENT_STATUS_FOR_DROPDOWN_WITH_ALL = addAllValue(
  PATIENT_STATUS_FOR_DROPDOWN
)

export const PATIENT_STATUS_FILTER_WITH_ALL = addAllValue(
  PATIENT_STATUS_FOR_DROPDOWN.filter(
    ({ title }) => !['Pending', 'Inactive'].includes(title)
  )
)

export const PATIENT_STATUS_FILTER_V5 = Array.from(statusesByName)
  .map(([title, value]) => ({ title, value, label: title }))
  .sort((a, b) => {
    if (a.title < b.title) {
      return -1
    } else if (a.title > b.title) {
      return 1
    }

    return 0
  })

export const PATIENT_STATUS_FILTER_WITH_ALL_V5 = addAllValueV5({
  list: PATIENT_STATUS_FILTER_V5.filter(
    ({ title }) => !['Pending', 'Inactive'].includes(title)
  ),
  convertList: true
})

export const PATIENT_STATUS_FILTER_WITH_PENDING_ALL_V5 = addAllValueV5({
  list: PATIENT_STATUS_FILTER_V5.filter(
    ({ title }) => !['Inactive'].includes(title)
  ),
  convertList: true
})

export const PATIENT_STATUS_FILTER_PENDING_WITH_ALL = addAllValue(
  PATIENT_STATUS_FOR_DROPDOWN.filter(
    ({ title }) => !['Inactive'].includes(title)
  )
)

export const PATIENT_STATUS_FILTER_NO_DISCHARGED_WITH_ALL = addAllValue(
  PATIENT_STATUS_FOR_DROPDOWN.filter(
    ({ title }) => !['Pending', 'Inactive', 'Discharged'].includes(title)
  )
)

export const PATIENT_STATUS_FILTER_NO_DISCHARGED_WITH_ALL_V5 = addAllValueV5({
  list: PATIENT_STATUS_FOR_DROPDOWN.filter(
    ({ title }) => !['Pending', 'Inactive', 'Discharged'].includes(title)
  ),
  convertList: true
})

export const PATIENT_STATUS_NO_PENDING_WITH_ALL = addAllValue(
  PATIENT_STATUS_FOR_DROPDOWN.filter(({ title }) => title !== 'Pending')
)

export const PATIENT_STATUS_NO_PENDING_WITH_ALL_V5 = addAllValueV5({
  list: PATIENT_STATUS_FOR_DROPDOWN.filter(({ title }) => title !== 'Pending'),
  convertList: true
})

export const PATIENT_STATUS_FILTER_WITH_ACTIVE_DISCHARGED_ALL_V5 =
  addAllValueV5({
    list: PATIENT_STATUS_FILTER_V5.filter(({ title }) =>
      ['Active', 'Discharged'].includes(title)
    ),
    convertList: true
  })

export const STATUSES_BY_NAME_UPPERCASE = new Map([
  [
    'ACTIVE',
    {
      title: 'Active',
      className: 'status-active',
      value: 1
    }
  ],
  [
    'PRE-ACTIVE',
    {
      title: 'Pre-active',
      className: 'status-pre-active',
      value: 2
    }
  ],
  [
    'PENDING',
    {
      title: 'Pending',
      className: 'status-pending',
      value: 1
    }
  ],
  [
    'DISCHARGED',
    {
      title: 'Discharged',
      className: 'status-discharged',
      value: 5
    }
  ],
  [
    'HOLD',
    {
      title: 'On Hold',
      className: 'status-on-hold',
      value: 4
    }
  ],
  [
    'INACTIVE',
    {
      title: 'Inactive',
      className: 'status-inactive',
      value: 0
    }
  ]
])

export const GOAL_ADD_STATUSES = Array.from(STATUSES_BY_NUMBERS)
  .map(([key, { title, value }]) => ({ key, value, label: title }))
  .filter(({ value }) =>
    [
      STATUSES_BY_NUMBERS.get(1).value,
      STATUSES_BY_NUMBERS.get(2).value
    ].includes(value)
  )

export const GOAL_ADD_BULK_STATUSES = Array.from(STATUSES_BY_NUMBERS)
  .map(([key, { title, value }]) => ({ key, value, label: title }))
  .filter(({ value }) =>
    [
      STATUSES_BY_NUMBERS.get(1).value,
      STATUSES_BY_NUMBERS.get(2).value,
      STATUSES_BY_NUMBERS.get(10).value
    ].includes(value)
  )

export const INTERVENTION_ADD_STATUSES = Array.from(STATUSES_BY_NUMBERS)
  .map(([key, { title, value }]) => ({ key, value, label: title }))
  .filter(({ value }) =>
    [
      STATUSES_BY_NUMBERS.get(1).value,
      STATUSES_BY_NUMBERS.get(2).value,
      STATUSES_BY_NUMBERS.get(10).value
    ].includes(value)
  )

export const GOAL_AND_INTERVENTION_EDIT_STATUSES = Array.from(
  STATUSES_BY_NUMBERS
)
  .map(([key, { title, value }]) => ({ key, value, label: title }))
  .filter(
    ({ value }) =>
      ![
        STATUSES_BY_NUMBERS.get(0).value,
        STATUSES_BY_NUMBERS.get(3).value,
        STATUSES_BY_NUMBERS.get(4).value
      ].includes(value)
  )

export const GOAL_AND_INTERVENTION_EDIT_STATUSES_WITH_ALL = addAllValueV5({
  list: GOAL_AND_INTERVENTION_EDIT_STATUSES,
  convertList: false
})

export const APPOINTMENT_STATUS_ICONS_BY_NAME = new Map([
  ['No show', faUserSlash],
  ['Canceled', 'circle-xmark'],
  ['Rescheduled', 'clock'],
  ['Canceled by clinician', 'ban'],
  ['Missed', faPhoneMissed]
])

export const TELEMEDICINE_VISIT_TYPE = new Map([
  [1, 'Initial'],
  [2, 'Revisit'],
  [null, 'None']
])

export const TELEMEDICINE_VISIT_TYPE_OPTIONS = Array.from(
  TELEMEDICINE_VISIT_TYPE
).map(([value, label]) => ({ value, label }))

// Display-only: TCM sub types are system-managed and not selectable in the form
export const TELEMEDICINE_VISIT_TYPE_LABELS = new Map<number | null, string>([
  ...TELEMEDICINE_VISIT_TYPE,
  [3, 'TCM'],
  [4, 'TCM non-billable']
])

export const PATIENT_NOTIFICATION_TYPES = {
  VIDEO: 1,
  AUDIO: 2,
  HOME_VISIT: 3
} as const

export const PATIENT_NOTIFICATION_TYPE_LABELS = new Map<number, string>([
  [PATIENT_NOTIFICATION_TYPES.VIDEO, 'Video'],
  [PATIENT_NOTIFICATION_TYPES.AUDIO, 'Audio Only'],
  [PATIENT_NOTIFICATION_TYPES.HOME_VISIT, 'Home Visit']
])

export const PATIENT_NOTIFICATION_TYPE_OPTIONS = Array.from(
  PATIENT_NOTIFICATION_TYPE_LABELS
).map(([value, label]) => ({ value, label }))

export const isVideoPatientNotificationType = (
  patientNotificationType?: number | null
) =>
  patientNotificationType === PATIENT_NOTIFICATION_TYPES.VIDEO ||
  patientNotificationType === PATIENT_NOTIFICATION_TYPES.HOME_VISIT
